import React, {} from "react"

export default function DowngradeProcessPost(res) {
    //  close the popups
    // console.log('downgrade complete')
    this.setState(
        {
            subscription_popup_info_open: false,
            subscription_popup_info_text_1: "",
            subscription_popup_info_text_2: "",
            subscription_popup_info_button_text: "",
            subscription_popup_info_button_click_process: () => {},
            subscribe_popup_open: false,
            subscribe_popup_icon_image: "",
            subscribe_popup_influencer_name: "",
            subscribe_popup_influencer: "",
            subscribe_popup_current_tier: "",
            subscribe_popup_minimum_tier: "",
            subscribe_popup_bronze_price: "",
            subscribe_popup_silver_price: "",
            subscribe_popup_gold_price: "",
        }
    )
}
